import React from 'react';
import { useTranslation } from '../hooks/useTranslation';
import { LanguageSelector } from './LanguageSelector';

export function AppHeader() {
  const { t } = useTranslation();
  
  return (
    <>
      <div className="absolute top-4 right-4">
        <LanguageSelector />
      </div>
      <div className="text-center">
        <div className="flex items-center justify-center gap-4">
          <img src="/logo.png" alt={t('app.title')} className="h-12 w-auto" />
          <h1 className="text-4xl font-bold text-indigo-900 mb-2">
            {t('app.title')}
          </h1>
        </div>
        <p className="text-indigo-600">{t('app.tagline')}</p>
      </div>
    </>
  );
} 